import { useState } from "react";
import { Link } from "react-router-dom";
import type { Episode } from "@/types/drama";

interface EpisodeListProps {
  dramaId: string;
  episodes: Episode[];
}

export default function EpisodeList({ dramaId, episodes }: EpisodeListProps) {
  const [expanded, setExpanded] = useState<string | null>(episodes[0]?.id ?? null);

  return (
    <section id="episodes" className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950">
          <i className="ri-list-ordered text-primary-500"></i>
          分集剧情
        </h2>
        <span className="text-xs text-foreground-500">共 {episodes.length} 集</span>
      </div>

      <ul className="flex flex-col divide-y divide-background-200">
        {episodes.map((episode) => {
          const isOpen = expanded === episode.id;
          return (
            <li key={episode.id} className="py-3 first:pt-0 last:pb-0">
              <div className="flex items-center gap-3">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-100 font-heading text-sm font-semibold text-primary-700">
                  {episode.number}
                </span>
                <button
                  type="button"
                  onClick={() => setExpanded(isOpen ? null : episode.id)}
                  className="flex min-w-0 flex-1 cursor-pointer items-center justify-between gap-2 text-left"
                >
                  <span className="min-w-0">
                    <span className="block truncate text-sm font-medium text-foreground-900">{episode.title}</span>
                    <span className="mt-0.5 block text-[11px] text-foreground-500">
                      {episode.airDate} · {episode.duration}
                    </span>
                  </span>
                  <i
                    className={`shrink-0 text-foreground-400 transition-transform ${isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}`}
                  ></i>
                </button>
              </div>
              {isOpen && (
                <div className="mt-3 rounded-lg bg-background-100 p-3">
                  <p className="text-xs leading-relaxed text-foreground-700">{episode.summary}</p>
                  <Link
                    to={`/detail/${dramaId}/episode/${episode.id}`}
                    className="mt-2 inline-flex items-center gap-1 whitespace-nowrap text-xs font-medium text-primary-600 transition-colors hover:text-primary-700"
                  >
                    阅读本集完整剧情
                    <i className="ri-arrow-right-s-line"></i>
                  </Link>
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}